import { Box } from '@mui/material';
import { Authenticator } from '@aws-amplify/ui-react';
import { Header } from './Header';

// eslint-disable-next-line import/no-unresolved
import '@aws-amplify/ui-react/styles.css';

const amplifyStyle = {
  height: '100%',
  lineHeight: 'normal',
  overflowY: 'auto',

  '[data-amplify-authenticator]': {
    '@media (max-width: 600px)': {
      '& [data-amplify-container]': {
        placeSelf: 'start stretch',
        width: '100%',
      },
      '& [data-amplify-router]': {
        borderRadius: 0,
        boxShadow: 'none',
      },
    },

    '& [data-amplify-router]': {
      border: 'none',
      borderRadius: { xs: 0, sm: '6px' },
      boxShadow: { xs: 'none', sm: '1px 1px 4px #00000026' },
    },

    '& .amplify-heading': { fontSize: 18, fontWeight: 'normal' },
    '& .amplify-heading--3': { mb: 2 },
    '& .amplify-field__show-password': { display: 'none' },
    '& .amplify-button--primary': { backgroundColor: '#333' },

    '& .amplify-button--link': {
      color: '#333',
      '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.05)' },
    },
  },
};

export function Amplify({ children }) {
  return (
    <Box sx={amplifyStyle}>
      <Authenticator hideSignUp components={{ Header }}>
        {children}
      </Authenticator>
    </Box>
  );
}
